import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuidV4 from 'uuid/v4';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import Label from '@spothero/ui/label';
import TextInput from '@spothero/ui/text-input';
import ValidationUtils from '@spothero/utils/validation';
import withConfig from 'config/withConfig';

class PhoneNumber extends Component {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        className: PropTypes.string,
        phoneNumberRequired: PropTypes.bool,
        phone: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        showLabel: PropTypes.bool,
        focus: PropTypes.bool,
        placeholder: PropTypes.string,
    };
    static defaultProps = {
        showLabel: true,
    };
    state = {
        key: uuidV4(),
        prevPhone: this.props.phone,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const {phone} = nextProps;

        if (phone !== prevState.prevPhone) {
            return {
                key: uuidV4(),
                prevPhone: phone,
            };
        }

        return null;
    }

    submit() {
        return this._form.submit();
    }

    render() {
        const {
            isMobile,
            phoneNumberRequired,
            className,
            placeholder,
            showLabel,
            phone,
            focus,
        } = this.props;
        const {key} = this.state;
        const classes = classNames('PhoneNumber', 'FormElement', className);
        const label = phoneNumberRequired ? 'Phone' : 'Phone (optional)';
        const fieldPlaceholder = placeholder
            ? placeholder
            : isMobile
            ? label
            : '';

        return (
            <Form
                ref={node => {
                    this._form = node;
                }}
                id="PhoneNumber-form"
                className={classes}
            >
                <TextInput
                    key={key}
                    type="tel"
                    name="phone"
                    label={showLabel ? <Label>{label}</Label> : null}
                    placeholder={fieldPlaceholder}
                    pattern={ValidationUtils.PHONE}
                    error={
                        <FormElementError>
                            Please enter a valid phone number.
                        </FormElementError>
                    }
                    mask="(999) 999-9999"
                    defaultValue={phone ? phone : null}
                    required={phoneNumberRequired}
                    focus={focus}
                />
            </Form>
        );
    }
}

export default withConfig(['isMobile'])(PhoneNumber);
